import { ViewEventModel } from 'functions/app/event/view'
import { pages } from '../links'

export const buildEventJsonLd = ({
  event,
  rootDomain,
}: {
  event: ViewEventModel
  rootDomain: string
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: event.title,
  description: event.intro,
  url: `${rootDomain}${pages.event(event.slug)}`,
  image: event.images?.[0]?.src,
  startDate: event.start ? new Date(event.start).toISOString() : undefined,
  endDate: event.end ? new Date(event.end).toISOString() : undefined,
  location: event.location?.address
    ? {
        '@type': 'Place',
        name: event.location.address,
      }
    : undefined,
})
